import React, { useEffect, useState } from "react";
import { IoMdArrowDropdown, IoMdMenu, IoMdArrowDropup } from "react-icons/io"; // Added ArrowDropup
import { useNavigate, useLocation as useRouteLocation } from "react-router-dom";
import SummaryApi from "../common";
import locationGif from "../Assets/Slide3/LocationGifImg.gif";

const MyNavbar = () => {
  const [eventsDropdown, setEventsDropdown] = useState(false);
  const [coursesDropdown, setCoursesDropdown] = useState(false);
  const [facilitiesDropdown, setFacilitiesDropdown] = useState(false);
  
  // NEW: State for mobile facilities dropdown
  const [mobileFacilitiesOpen, setMobileFacilitiesOpen] = useState(false);
  
  const [events, setEvents] = useState([]);
  const [uniqueCategoryNames, setUniqueCategoryNames] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const routeLocation = useRouteLocation();

  useEffect(() => {
    fetch(SummaryApi.getevents.url, {
      method: "get",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.data) {
          setEvents(data.data);
          const lastFiveEvents = data.data.slice(-5);
          const categoryNames = lastFiveEvents.map(
            (event) => event.category_name,
          );
          const uniqueCategories = [...new Set(categoryNames)];
          setUniqueCategoryNames(uniqueCategories);
        }
      })
      .catch((error) => console.error("Error fetching events:", error));
  }, []);

  const activeLinkStyle = { color: "#FDDA0D" };
  
  // Toggle main menu and reset sub-menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isMenuOpen) setMobileFacilitiesOpen(false);
  };

  const isActive = (path) =>
    routeLocation.pathname === path ? activeLinkStyle : {};

  const facilities = [
    { name: "Online Grievance Redressal Mechanism", path: "/facilities/online-grievance" },
    { name: "Anti-Ragging Committee", path: "/facilities/anti-ragging" },
    { name: "Internal Complaint Committee", path: "/facilities/internal-complaint" },
    { name: "Community for SC/ST", path: "/facilities/community-sc-st" },
    { name: "Food Safety", path: "/facilities/food-safety" },
    { name: "Board of Governors & Mandatory disclosure", path: "/facilities/board-of-governors" },
    { name: "Institution Industry Cell", path: "/facilities/institution-industry-cell" },
    { name: "AICTE Feedback Facility", path: "/facilities/aicte-approval" },
  ];

  return (
    <div className="bg-[#2C9CB5] text-white p-2 flex justify-between items-center sticky top-0 z-[99999] font-[Poly] sm:p-4 shadow-md">
      {/* Mobile Hamburger Icon */}
      <div className="lg:hidden flex justify-between w-full items-center">
        <IoMdMenu size={50} onClick={toggleMenu} className="cursor-pointer" />
        <a href="/RouteMap" className="flex items-center">
          <img src={locationGif} className="w-10 h-10" alt="location" />
        </a>
      </div>

      {/* Desktop Menu */}
      <div className="hidden lg:flex flex-grow justify-center items-center gap-x-8">
        <a href="/" className="text-2xl hover:text-[#FDDA0D] transition-all" style={isActive("/")}>Home</a>
        <a href="/about" className="text-2xl hover:text-[#FDDA0D] transition-all" style={isActive("/about")}>About</a>
        <a href="/Admissions" className="text-2xl hover:text-[#FDDA0D] transition-all" style={isActive("/Admissions")}>Admissions</a>

        {/* Courses Dropdown (Desktop) */}
        <div className="relative" onMouseEnter={() => setCoursesDropdown(true)} onMouseLeave={() => setCoursesDropdown(false)}>
          <a href="/courses" className="text-2xl flex items-center hover:text-[#FDDA0D]">Courses <IoMdArrowDropdown /></a>
          {coursesDropdown && (
            <div className="absolute left-0 bg-[#2C9CB5] w-44 rounded-b-lg shadow-xl border-t-2 border-[#FDDA0D] overflow-hidden">
              <div className="grid grid-cols-2">
                {["AIML", "CCB", "CME", "CIV", "ECE", "EEE", "MEC"].map((course, idx) => (
                    <a key={idx} href={`/course-details/${idx + 1}`} className="block px-4 py-3 text-lg hover:bg-[#1f7d8b] border-b border-white/10 transition-colors">{course}</a>
                ))}
              </div>
            </div>
          )}
        </div>

        <a href="/Examcell" className="text-2xl hover:text-[#FDDA0D]" style={isActive("/Examcell")}>Exam Cell</a>

        {/* Other Facilities Dropdown (Desktop) */}
        <div className="relative" onMouseEnter={() => setFacilitiesDropdown(true)} onMouseLeave={() => setFacilitiesDropdown(false)}>
          <button className="text-2xl flex items-center hover:text-[#FDDA0D] bg-transparent border-none cursor-pointer text-white font-[Poly]">
            Other Facilities <IoMdArrowDropdown className={`transition-transform ${facilitiesDropdown ? "rotate-180" : ""}`} />
          </button>
          {facilitiesDropdown && (
            <div className="absolute left-0 mt-0 bg-[#2C9CB5] w-60 rounded-b-lg shadow-2xl border-t-2 border-[#FDDA0D] overflow-hidden z-[99999]">
              {facilities.map((facility, index) => (
                <a key={index} href={facility.path} className="block px-5 py-4 text-[1.1rem] leading-snug text-white hover:bg-[#1f7d8b] border-b border-white/10 last:border-none transition-all duration-200">{facility.name}</a>
              ))}
            </div>
          )}
        </div>

        {/* Events Dropdown (Desktop) */}
        <div className="relative" onMouseEnter={() => setEventsDropdown(true)} onMouseLeave={() => setEventsDropdown(false)}>
          <a href="/EventS" className="text-2xl flex items-center hover:text-[#FDDA0D]">Events <IoMdArrowDropdown /></a>
          {eventsDropdown && (
            <div className="absolute left-0 bg-[#2C9CB5] w-34 rounded-b-lg shadow-xl border-t-2 border-[#FDDA0D] overflow-hidden">
              {uniqueCategoryNames.map((cat, i) => (
                <div key={i} onClick={() => navigate("/EventS")} className="px-5 py-3 text-lg cursor-pointer hover:bg-[#1f7d8b] border-b border-white/10 last:border-none">{cat}</div>
              ))}
            </div>
          )}
        </div>

        <a href="/form" className="text-2xl hover:text-[#FDDA0D]" style={isActive("/form")}>Contact</a>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 w-full bg-[#2C9CB5] text-white py-2 flex flex-col z-[9999] shadow-2xl border-t border-white/20 max-h-[80vh] overflow-y-auto">
          <a href="/" className="text-xl px-6 py-4 border-b border-white/10">Home</a>
          <a href="/about" className="text-xl px-6 py-4 border-b border-white/10">About</a>
          <a href="/Admissions" className="text-xl px-6 py-4 border-b border-white/10">Admissions</a>
          <a href="/Examcell" className="text-xl px-6 py-4 border-b border-white/10">Exam Cell</a>

          {/* --- MOBILE ACCORDION FOR OTHER FACILITIES --- */}
          <div className="border-b border-white/10">
            <button 
              onClick={() => setMobileFacilitiesOpen(!mobileFacilitiesOpen)}
              className="w-full flex justify-between items-center text-xl px-6 py-4 text-white font-[Poly]"
            >
              Other Facilities
              {mobileFacilitiesOpen ? <IoMdArrowDropup size={28} /> : <IoMdArrowDropdown size={28} />}
            </button>
            
            {mobileFacilitiesOpen && (
              <div className="bg-[#1f7d8b]/60 transition-all">
                {facilities.map((f, i) => (
                  <a
                    key={i}
                    href={f.path}
                    className="block py-4 px-10 text-lg border-b border-white/5 last:border-none active:bg-[#FDDA0D] active:text-[#2C9CB5]"
                  >
                    {f.name}
                  </a>
                ))}
              </div>
            )}
          </div>

          <a href="/EventS" className="text-xl px-6 py-4 border-b border-white/10">Events</a>
          <a href="/form" className="text-xl px-6 py-4">Contact</a>
        </div>
      )}
    </div>
  );
};

export default MyNavbar;